"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pushItem = pushItem;
exports.pushItems = pushItems;
exports.pushList = pushList;
exports.pushListPage = pushListPage;
exports.removeItem = removeItem;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _lodash = _interopRequireDefault(require("lodash"));

var _invariant = _interopRequireDefault(require("invariant"));

/**
 * Push list (initial page)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */
function pushList(state, action) {
  var _action$meta$original = action.meta.originalPayload,
      id = _action$meta$original.id,
      uuid = _action$meta$original.uuid;
  var data = action.payload.data;
  (0, _invariant.default)(id, 'To push a list the list ID needs to be defined in the original request!');
  (0, _invariant.default)(data && _lodash.default.isArray(data), 'You need to define the data array you want to push as a list');
  state = (0, _entityNormalizer.setEntityList)(state, id, action.payload);
  state = (0, _entityNormalizer.addListConsumer)(state, id, uuid);
  (0, _forEach.default)(data).call(data, function (_ref) {
    var item = _ref.item;

    if (!item || !item.id) {
      // Skip nulled items!
      return;
    }

    var listConsumers = _lodash.default.get(state, "lists.".concat(id, ".consumers"), []);

    (0, _forEach.default)(listConsumers).call(listConsumers, function (cUuid) {
      state = (0, _entityNormalizer.addItemConsumer)(state, item.id, cUuid);
    });
    state = (0, _entityNormalizer.setEntityItemStatus)(state, item.id, _entityNormalizer.STATUS_LOADED);
  });
  state = (0, _entityNormalizer.setEntityListStatus)(state, id, _entityNormalizer.STATUS_LOADED);
  return state;
}
/**
 * Push a specific list page
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function pushListPage(state, action) {
  var _context;

  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var _action$meta$original2 = action.meta.originalPayload,
      id = _action$meta$original2.id,
      uuid = _action$meta$original2.uuid,
      isRefreshing = _action$meta$original2.isRefreshing;
  (0, _invariant.default)(id, 'To push a list page the list ID needs to be defined in the original request!');
  (0, _invariant.default)(action.payload.data && _lodash.default.isArray(action.payload.data), 'You need to define the data array you want to push as a list');
  state = (0, _entityNormalizer.setEntityListPage)(state, id, action.payload, page);
  state = (0, _entityNormalizer.addListConsumer)(state, id, uuid);
  (0, _forEach.default)(_context = action.payload.data).call(_context, function (_ref2) {
    var item = _ref2.item;

    if (!item || !item.id) {
      return;
    }

    var listConsumers = _lodash.default.get(state, "lists.".concat(id, ".consumers"), []);

    (0, _forEach.default)(listConsumers).call(listConsumers, function (cUuid) {
      state = (0, _entityNormalizer.addItemConsumer)(state, item.id, cUuid);
    });
    state = (0, _entityNormalizer.setEntityItemStatus)(state, item.id, _entityNormalizer.STATUS_LOADED);
  });

  if (!isRefreshing) {
    state = (0, _entityNormalizer.setEntityListStatus)(state, id, _entityNormalizer.STATUS_LOADED);
  }

  return state;
}
/**
 * Push single item
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function pushItem(state, action) {
  var _action$payload = action.payload,
      actionUuid = _action$payload.uuid,
      data = _action$payload.data,
      source = _action$payload.source,
      related = _action$payload.related,
      args = _action$payload.args;
  var originalUuid = action.meta.originalPayload.uuid;
  var uuid = actionUuid || originalUuid;
  state = (0, _entityNormalizer.setEntityItem)(state, data.id, data, source, related, args);
  state = (0, _entityNormalizer.addItemConsumer)(state, data.id, uuid);
  return (0, _entityNormalizer.setEntityItemStatus)(state, data.id, _entityNormalizer.STATUS_LOADED);
}
/**
 * Push multiple items to the store at once
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function pushItems(state, action) {
  var _action$payload2 = action.payload,
      uuid = _action$payload2.uuid,
      source = _action$payload2.source,
      related = _action$payload2.related,
      items = _action$payload2.items,
      args = _action$payload2.args;
  (0, _invariant.default)(items && _lodash.default.isArray(items), 'You need to define the items you want to push');
  (0, _forEach.default)(items).call(items, function (item) {
    var rel = related[item.id];
    state = (0, _entityNormalizer.setEntityItem)(state, item.id, item, source, rel);
    state = (0, _entityNormalizer.addItemConsumer)(state, item.id, uuid, args);
    state = (0, _entityNormalizer.setEntityItemStatus)(state, item.id, _entityNormalizer.STATUS_LOADED);
  });
  return state;
}
/**
 * Remove a single item from the store
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function removeItem(state, action) {
  return (0, _entityNormalizer.removeEntityItem)(state, action.meta.originalPayload.id);
}